import Vue from "vue";
import formTorvallaBilOpen from "./components/form-torvalla-bil-open.vue";
import store from "./store";
import "./assets/main.scss";
import axios from 'axios';
import VueAxios from 'vue-axios';
import Vuelidate from 'vuelidate';
import { email } from "vuelidate/lib/validators";

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(Vuelidate);

// Registrera torvalla-bil-open-formuläret i ModalManager
if (window.modalManager) {
    window.modalManager.registerFormType('torvalla-bil-open', {
        Vue: Vue,
        formComponent: formTorvallaBilOpen,
        store: store
    });
}

/**
 * Global function to create and mount a torvalla-bil-open form app
 * Now uses ModalManager for centralized form handling
 * @param {string} selector - CSS selector for the target DOM element
 * @param {Object} props - Optional props to override element attributes
 * @returns {Vue|undefined} The mounted Vue instance, or undefined on error
 * @global
 */
window.createApp_torvalla_bil_open = function(selector, props = {}) {
    if (!window.modalManager) {
        console.error('ModalManager not available for createApp_torvalla_bil_open');
        return;
    }

    // Registrera torvalla-bil-open-formuläret om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered('torvalla-bil-open')) {
        window.modalManager.registerFormType('torvalla-bil-open', {
            Vue: Vue,
            formComponent: formTorvallaBilOpen,
            store: store
        });
    }

    return window.modalManager.createFormApp('torvalla-bil-open', selector, props);
};

/**
 * Automatically initializes all torvalla-bil-open forms found in the DOM
 * Now uses ModalManager for centralized form handling
 * @returns {boolean} True if forms were found and processed, false if no forms exist
 */
let renderTorvallaBilOpenForms = function() {
    // Early exit if no forms exist on page
    const forms = document.querySelectorAll('.form-torvalla-bil-open');
    if (forms.length === 0) {
        return false;
    }

    if (!window.modalManager) {
        console.error('ModalManager not available for renderTorvallaBilOpenForms');
        return false;
    }

    // Registrera torvalla-bil-open-formuläret i ModalManager om det inte redan är registrerat
    if (!window.modalManager.isFormTypeRegistered || !window.modalManager.isFormTypeRegistered('torvalla-bil-open')) {
        window.modalManager.registerFormType('torvalla-bil-open', {
            Vue: Vue,
            formComponent: formTorvallaBilOpen,
            store: store
        });
    }

    forms.forEach((form, index) => {
        try {
            const parentBlock = form.closest('.nitea-form-selector');

            if (parentBlock) {
                // Inbäddade block initieras av form-selector/view.js (undvik dubbel mount)
                return;
            }


                // Footer/manual context: Force modal mode by setting display mode to modal
                if (!form.id) {

                    form.id = `form-torvalla-bil-open-footer-${Date.now()}-${index}`;

                }

                window.modalManager.createFormApp('torvalla-bil-open', `#${form.id}`, {
                    displayMode: 'modal'
                });
        } catch (error) {
            console.error(`Failed to initialize torvalla-bil-open form ${index}:`, error);
        }
    });

    return true;
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderTorvallaBilOpenForms);
} else {
    renderTorvallaBilOpenForms();
}


/**
 * Expose renderTorvallaBilOpenForms globally for debugging and manual re-initialization
 * @global
 */
window.renderTorvallaBilOpenForms = renderTorvallaBilOpenForms;
